<template>
  <SettingsCard
    :title="$t('settings.email.domain-settings.title')"
    :subtitle="$t('settings.email.domain-settings.subtitle')"
    icon="mdi-email-seal"
    :model-value="isOpen"
    @update:modelValue="setOpen"
  >
    <div class="pa-4">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          class="px-0 px-md-2"
        >
          <div>
            <div class="d-flex align-center">
              <span class="font-weight-bold">
                {{ $t('settings.email.domain-settings.body-texts.0') }}
              </span>
            </div>
            <div class="text-grey mb-2">
              {{ $t('settings.email.domain-settings.body-texts.1') }}
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="d-flex flex-column px-0 px-md-2"
        >
          <div class="mr-12 d-flex align-center justify-space-between">
            <v-text-field
              class="font-weight-bold"
              label="Domain"
              hide-details
              readonly
              variant="outlined"
              auto-grow
              no-resize
              rows="1"
              :model-value="domain.domain"
              @click="onClick('Domain', domain.domain)"
            />
          </div>
        </v-col>
      </v-row>
    </div>
    <div
      v-if="hoppermation.hasDKIMVerification"
      class="pa-4"
    >
      <v-row>
        <v-col
          cols="12"
          sm="6"
          class="px-0 px-md-2"
        >
          <div>
            <div class="d-flex align-center">
              <span class="font-weight-bold">
                {{ $t('settings.email.domain-settings.dkim-texts.0') }}
              </span>
            </div>
            <div class="text-grey mb-2">
              <span class="font-weight-bold"
                >{{ $t('settings.email.domain-settings.dkim-texts.1') }}<br
              /></span>
              {{ $t('settings.email.domain-settings.dkim-texts.2') }}
            </div>
            <div class="text-grey mb-2">
              <span class="font-weight-bold"
                >{{ $t('settings.email.domain-settings.dkim-texts.3') }}<br
              /></span>
              {{ $t('settings.email.domain-settings.dkim-texts.4') }}
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="d-flex flex-column px-0 px-md-2"
        >
          <div class="mb-4 d-flex align-center justify-space-between">
            <div
              v-if="domain.isDKIMVerified"
              class="font-weight-bold"
            >
              <v-icon
                color="success"
                class="pr-4"
              >
                mdi-check-decagram
              </v-icon>
              <span>{{ $t('settings.email.domain-settings.labels.verified') }}</span>
            </div>

            <div
              v-else
              class="font-weight-bold"
            >
              <v-icon
                color="error"
                class="pr-4"
              >
                mdi-alert-decagram
              </v-icon>
              <span>{{ $t('settings.email.domain-settings.labels.not-verified') }}</span>
            </div>
            <v-btn
              v-if="!domain.isDKIMVerified"
              variant="outlined"
              color="primary"
              class="px-2 option-btn"
              :loading="isLoading"
              :disabled="isLoading"
              @click="verifyDKIM"
            >
              {{ $t('buttons.verify.cta') }}
            </v-btn>
          </div>
          <div>
            <div class="d-flex">
              <v-textarea
                class="mb-4"
                :label="$t('settings.email.domain-settings.labels.hostname')"
                hide-details
                readonly
                variant="outlined"
                auto-grow
                no-resize
                rows="1"
                :model-value="domain.dkimHost"
                @click="onClick('Hostname', domain.dkimHost)"
              />

              <CopyToClipboardButton :value="domain.dkimHost" />
            </div>
            <div class="d-flex">
              <v-textarea
                class="mb-4"
                :label="$t('settings.email.domain-settings.labels.txt-entry')"
                hide-details
                readonly
                variant="outlined"
                auto-grow
                no-resize
                :model-value="domain.dkimText"
                @click="onClick('TXT Entry', domain.dkimText)"
              />
              <CopyToClipboardButton :value="domain.dkimText" />
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div
      v-if="hoppermation.hasReturnPathVerification"
      class="pa-4"
    >
      <v-row>
        <v-col
          cols="12"
          sm="6"
          class="px-0 px-md-2"
        >
          <div>
            <div class="d-flex align-center">
              <span class="font-weight-bold">
                {{ $t('settings.email.domain-settings.return-path-texts.0') }}
              </span>
            </div>
            <div class="text-grey mb-2">
              <span class="font-weight-bold"
                >{{ $t('settings.email.domain-settings.return-path-texts.1') }}<br
              /></span>
              {{ $t('settings.email.domain-settings.return-path-texts.2') }}
            </div>
            <div class="text-grey mb-2">
              <span class="font-weight-bold"
                >{{ $t('settings.email.domain-settings.return-path-texts.3') }}<br
              /></span>
              {{ $t('settings.email.domain-settings.return-path-texts.4') }}
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="d-flex flex-column px-0 px-md-2"
        >
          <div class="mb-4 d-flex align-center justify-space-between">
            <div
              v-if="domain.isReturnPathDomainVerified"
              class="font-weight-bold"
            >
              <v-icon
                color="success"
                class="pr-4"
              >
                mdi-check-decagram
              </v-icon>
              <span>{{ $t('settings.email.domain-settings.labels.verified') }}</span>
            </div>

            <div
              v-else
              class="font-weight-bold"
            >
              <v-icon
                color="error"
                class="pr-4"
              >
                mdi-alert-decagram
              </v-icon>
              <span>{{ $t('settings.email.domain-settings.labels.not-verified') }}</span>
            </div>
            <v-btn
              v-if="!domain.isReturnPathDomainVerified"
              variant="outlined"
              color="primary"
              class="px-2 option-btn"
              :disabled="isLoading"
              :loading="isLoading"
              @click="verifyReturnPath"
            >
              {{ $t('buttons.verify.cta') }}
            </v-btn>
          </div>
          <div>
            <div class="d-flex">
              <v-textarea
                class="mb-4"
                :label="$t('settings.email.domain-settings.labels.hostname')"
                hide-details
                readonly
                variant="outlined"
                auto-grow
                no-resize
                rows="1"
                :model-value="domain.returnPathDomain"
                @click="onClick('Hostname', domain.returnPathDomain)"
              />
              <CopyToClipboardButton :value="domain.returnPathDomain" />
            </div>
            <div class="d-flex">
              <v-textarea
                class="mb-4"
                :label="$t('settings.email.domain-settings.labels.cname-entry')"
                hide-details
                readonly
                variant="outlined"
                :rows="1"
                auto-grow
                no-resize
                :model-value="domain.returnPathDomainCname"
                @click="onClick('CNAME Entry', domain.returnPathDomainCname)"
              />
              <CopyToClipboardButton :value="domain.returnPathDomainCname" />
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-alert
      v-if="hoppermation.hasReturnPathVerification || hoppermation.hasDKIMVerification"
      icon="mdi-lightbulb-on-20"
      prominent
      variant="tonal"
      type="info"
      class="ma-0 mb-8"
    >
      <p class="ma-0 font-weight-bold">
        {{ $t('settings.email.domain-settings.howto-texts.0') }}
      </p>
      <ol>
        <li>
          {{ $t('settings.email.domain-settings.howto-texts.1') }}<br />
          <a
            href="https://postmarkapp.com/support/article/1090-resources-for-adding-dkim-and-return-path-records-to-dns-for-common-hosts-and-dns-providers"
            target="_blank"
            rel="noopener"
            >{{ $t('settings.email.domain-settings.howto-texts.2') }}</a
          >
        </li>
        <li>
          {{ $t('settings.email.domain-settings.howto-texts.3') }}
        </li>
      </ol>
    </v-alert>
    <VerifyDomainDialog
      :dialog="verifyDialog"
      @close="verifyDialog = false"
    />
  </SettingsCard>
</template>

<script>
import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue'
import SettingsCard from '@/components/SettingsCard.vue'
import { useQueryOpen } from '@/composables/useQueryOpen'
import { clipboard } from '@/lib/clipboard'
import bus, { eventNames } from '@/lib/eventBus'
import featureNames from '@/lib/featureNames'
import featureMixin from '@/mixins/feature'
import GET_DOMAIN from '@/queries/GetDomain.gql'

import VERIFY_DOMAIN from './queries/VerifyDomain.gql'
import VerifyDomainDialog from './VerifyDomainDialog.vue'

export default {
  setup() {
    const { isOpen, setOpen } = useQueryOpen({ settingName: 'domain' })
    return {
      isOpen,
      setOpen,
    }
  },
  components: { SettingsCard, VerifyDomainDialog, CopyToClipboardButton },
  mixins: [featureMixin],
  data() {
    return {
      isLoading: false,
      verifyDialog: false,
      domain: {},
    }
  },
  computed: {
    hoppermation() {
      const { config: { hasDKIMVerification, hasReturnPathVerification } = { config: {} } } =
        this.getFeature(featureNames.HOPPERMATION)
      return {
        hasDKIMVerification,
        hasReturnPathVerification,
      }
    },
  },
  methods: {
    onClick(label, value) {
      this.$tracking.event('Settings', 'Clicked', label, value)
    },
    async verifyDKIM() {
      this.onClick('Verify DKIM', true)
      await this.verifyDomain()
      if (!this.domain.isDKIMVerified) {
        this.verifyDialog = true
      }
    },
    async verifyReturnPath() {
      this.onClick('Verify Return Path', true)
      await this.verifyDomain()
      if (!this.domain?.isReturnPathDomainVerified) {
        this.verifyDialog = true
      }
    },
    async copyToClipboard(value) {
      this.$tracking.event('Settings', 'Clicked', 'Copy to Clipboard')
      bus.$emit(eventNames.SHOW_SNACKBAR, {
        color: 'success',
        text: this.$t('alerts.settings.email.domain-settings.success-copy'),
      })

      return await clipboard(value)
    },
    async verifyDomain() {
      try {
        this.isLoading = true
        await this.$apollo.mutate({
          mutation: VERIFY_DOMAIN,
          variables: {
            companyId: this.$auth.user.companyId,
          },
          update: (store, { data: { domain } }) => {
            store.writeQuery({
              query: GET_DOMAIN,
              data: { domain },
              variables: { companyId: this.$auth.user.companyId },
            })
          },
        })
        this.$tracking.event('Settings', 'Clicked', 'Verify Domain')
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'success',
          text: this.$t('alerts.settings.email.domain-settings.success'),
        })
      } catch (e) {
        bus.$emit(eventNames.SHOW_SNACKBAR, {
          color: 'error',
          text: this.$t('alerts.settings.email.domain-settings.error'),
        })
      } finally {
        this.isLoading = false
      }
    },
  },
  apollo: {
    domain: {
      query: GET_DOMAIN,
      variables() {
        return { companyId: this.$auth.user.companyId }
      },
    },
  },
}
</script>
